import React, { useState, useEffect } from 'react';
import FilterContainer from './FilterContainer';
import DropdownContainer from './DropdownContainer';

function FilterAccordionSingleSelect(props) {
    const {
        taxonomy,
        taxSlug,
        selected,
        displayPostCounts,
        label,
        showLabel,
        hideChildTerms,

        collapsible,
        scrollable,
        dropdown,

        replaceSelected,
        isSelected,
    } = props;

    const [closeRequest, setCloseRequest] = useState(false);
    const allTerms = [];
    const allTermsID = `${taxSlug}-all`;

    let parentContent;
    let childContent;
    let filterContent;

    function clickHandler(e, object) {
        e.preventDefault();
        replaceSelected(object.id, taxSlug);
    }

    function activeButtonClass(id) {
        let classString = '';

        if (isSelected(id, taxSlug)) {
            classString = 'active';
        }

        return classString;
    }

    if (taxonomy) {
        allTerms.push(
            <li id="all-terms" key="all">
                <button
                    type="button"
                    id={allTermsID}
                    onClick={(e) => {
                        e.preventDefault();
                        replaceSelected(allTermsID, taxSlug);
                        setCloseRequest(true);
                    }}
                    className={activeButtonClass(allTermsID)}
                >
                    All {label}
                </button>
            </li>
        );
        taxonomy.forEach((term) => {
            if(term.name !== "Uncategorized" && !term.hide_term){
            if (displayPostCounts) {
                parentContent = `${term.name} (${term.count})`;
            } else {
                parentContent = term.name;
            }

            allTerms.push(
                <li id={`term-${term.slug}`} className="parent-term" key={term.id}>
                    <button
                        id={`${taxSlug}-${term.id}`}
                        onClick={(e) => {
                            clickHandler(e, term), setCloseRequest(true);
                        }}
                        className={activeButtonClass(term.id)}
                    >
                        <span dangerouslySetInnerHTML={{ __html: parentContent }}></span>
                    </button>
                </li>
            );

            if (term.children && !hideChildTerms) {
                term.children.forEach((child) => {
                    if (displayPostCounts) {
                        childContent = `${child.name} (${child.count})`;
                    } else {
                        childContent = child.name;
                    }

                    allTerms.push(
                        <li id={`term-${child.slug}`} className="child-term" key={child.id}>
                            <button
                                id={`${taxSlug}-${child.id}`}
                                onClick={(e) => {
                                    clickHandler(e, child),
                                        setCloseRequest(true);
                                }}
                                className={activeButtonClass(child.id)}
                            >
                                <span dangerouslySetInnerHTML={{
                                    __html: childContent,
                                }}></span>
                            </button>
                        </li>
                    );
                });
            }
        }});
    }

    if (dropdown) {
        filterContent = (
            <DropdownContainer
                selected={selected}
                taxSlug={taxSlug}
                taxonomy={taxonomy}
                closeRequest={closeRequest}
                setCloseRequest={setCloseRequest}
                defaultLabel={label}
            >
                <ul className="dropdown-list">{allTerms}</ul>
            </DropdownContainer>
        );
    } else {
        filterContent = <ul>{allTerms}</ul>;
    }

    return (
        <FilterContainer
            className="filter-accordion-single-select"
            label={label}
            showLabel={showLabel}
            collapsible={collapsible}
            scrollable={scrollable}
            filterId={`filter-${taxSlug}`}
        >
            {filterContent}
        </FilterContainer>
    );
}

export default FilterAccordionSingleSelect;
